import { App } from "antd";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiPost, errorMessage, qk } from "@/shared/api";

/**
 * Прокрутка дня вперёд (AD-05).
 *
 * Кнопка одна, а последствий много: меняются балансы всех пользователей с
 * работающими роботами. Поэтому инвалидируется почти весь кэш — от списка
 * пользователей до истории начислений.
 */
export function useRollDay() {
  const queryClient = useQueryClient();
  const { message } = App.useApp();

  return useMutation({
    mutationFn: () => apiPost("/api/v1/admin/accruals/roll"),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: qk.dashboard() });
      void queryClient.invalidateQueries({ queryKey: ["users"] });
      void queryClient.invalidateQueries({ queryKey: ["accruals"] });
      void queryClient.invalidateQueries({ queryKey: ["audit"] });
    },
    onError: (error) => {
      void message.error(errorMessage(error));
    },
  });
}
